import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { NewsState } from '@/store/news/types';

export const getters: GetterTree<NewsState, RootState> = {
  //
};
